// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/soft_shadow_generate_texture.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'soft_shadow_generate_texturePixelShader';
const shader = `precision highp float;
varying vec2 vUV;
uniform highp sampler2D sourceTexture;
uniform float referenceHeight, intensity;
void main()
{
float h = texture(sourceTexture, vec2(1.0 - vUV.x, vUV.y)).r;
float dh = max(0.0, h - referenceHeight);
float alpha = 1.0 - exp(-dh * intensity);
gl_FragColor = vec4(0, 0, 0, alpha);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const soft_shadow_generate_texturePixelShader = { name, shader };
//# sourceMappingURL=soft_shadow_generate_texture.fragment.js.map